import React, { useState } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { Avatar, Dialog, DialogContent, Grid,
         TextField, Typography, Paper } from '@mui/material';
import LockIcon from '@mui/icons-material/LockTwoTone';
import Button from '../UI/Buttons/Button';
import { encryptString } from '../../helpers/securityHelper';
import { useTranslation } from 'react-i18next';

const Lockscreen = ({ open, toggleDialog }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth);
    const profile = useSelector(state => state.profile);

    const [errors, setErrors] = useState({});
    const [pin, setPin] = useState('');
    const [enableButton, setEnableButton] = useState(true);

    const handleSubmit = async () => {
        if (!enableButton) return;
        if (pin == null || pin === '') return;
        setEnableButton(false);
        try {
            const pinHash = encryptString(pin);
            const result = await axios.post('/api/userpinunlock', { userid: auth.user.id, pin: pinHash });
            setEnableButton(true);
            if (!result.data.expired) {
                if (result.data.confirmed) {
                    toggleDialog();
                    dispatch({ type: 'CREATE_ALERT', payload: { message: t('screenUnlocked'), title: t('success'), severity: 'success' } });
                } else {
                    setErrors({ [t('pin')]: t('pinIncorrect') });
                    dispatch({ type: 'CREATE_ALERT', payload: { message: t('pinIncorrect'), title: t('error'), severity: 'error' } });
                }
            } else {
                setErrors({ [t('pin')]: t('pinExpired') });
                dispatch({ type: 'CREATE_ALERT', payload: { message: t('pinExpired'), title: t('error'), severity: 'error' } });
            }
        } catch (error) {
            setErrors({ [t('pin')]: error.response.data });
            setEnableButton(true);
            dispatch({ type: 'CREATE_ALERT', payload: { message: error.response.data, title: t('error'), severity: 'error' } });
        }
    };

    return (
        <Dialog open={open} maxWidth='sm' fullWidth component={Paper}>
            <DialogContent>
                <Grid container sx={{ justifyContent: "center" }} spacing={1}>
                    <Grid size={12}>
                        <Avatar sx={{
                            backgroundColor: 'secondary.main',
                            color: '#FFF',
                            m: '0 auto',
                            width: '75px',
                            height: '75px'
                        }}>
                            <LockIcon sx={{ fontSize: '65px' }} />
                        </Avatar>
                        <Typography sx={{ fontSize: '24px', fontWeight: 'bold', color: 'grey[800]' }}>
                            {t('user')}:
                        </Typography>
                        <Typography sx={{ fontFamily: 'Poppins', fontSize: '45px', color: 'primary.main' }}>
                            {profile.profile.name}
                        </Typography>
                        <TextField required value={pin} onChange={(e) => setPin(e.target.value)} name="pin"
                            fullWidth label={t('pin')} margin="normal" variant="outlined" type="password"
                            helperText={errors[t('pin')]} error={errors[t('pin')] != null} />
                        <Button
                            variant='signIn'
                            sx={{ width: '100%' }}
                            disabled={!enableButton}
                            onClick={handleSubmit}
                        >{t('unlock')}</Button>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default Lockscreen;
